import React from 'react';
import { EntryCard } from './EntryCard';

export function GridView({ entries, duplicates, navigate }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="kennisbank-grid">
      {entries.map(entry => (
        <EntryCard key={entry.entry_id} entry={entry} duplicates={duplicates} navigate={navigate} variant="grid" />
      ))}
    </div>
  );
}
